import trans from '../../../helpers/trans';
import { PaymentMethodResource } from '../../@api/Sylius';
import { transformMeilisearchImageToImage } from '../../Media/MediaTransformers';
import { PaymentMethod } from './PaymentMethod';

export const transformToPaymentMethods = (resource: PaymentMethodResource): PaymentMethod => {
    const image = transformMeilisearchImageToImage({
        alt: resource.name,
        url: resource.imageUrl,
    });

    const label = resource.isGiftCard
        ? trans('entities.paymentMethod.giftCard')
        : resource.name;

    return {
        value: resource.id,
        label,
        image,
        isGiftCard: resource.isGiftCard,
    };
};
